import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import FormatDate from '../../Utils/FormatDate';

import classes from './styles.module.css';

import Context from '../../../Context';

function TableRow({ data, currentId }) {
    const status = {
        name: '',
        color: '',
    };

    switch (data.status) {
        case -1:
            status.name = <FormattedMessage id="AccountsList.status.inactive" defaultMessage="Не активен" />;
            status.color = '#ff9900';
            break;
        case -2:
            status.name = <FormattedMessage id="AccountsList.status.closed" defaultMessage="Закрыт" />;
            status.color = '#d4d4d4';
            break;
        case -3:
            status.name = <FormattedMessage id="AccountsList.status.blocked" defaultMessage="Заблокирован" />;
            status.color = 'rgb(220, 57, 18)';
            break;
        case 1:
            status.name = <FormattedMessage id="AccountsList.status.active" defaultMessage="Активен" />;
            status.color = 'rgb(16, 150, 24)';
            break;
        default:
            break;
    }

    const { onSelectAccountId } = useContext(Context);

    let styles = {};

    if (currentId === data.id) styles = { backgroundColor: '#e3f2fd' };

    return (
        <tr style={styles} className={classes.Row} onClick={() => onSelectAccountId(data.id)}>
            <td className={classes.CellCenter}>{data.id}</td>
            <td className={classes.Cell}>
                <FormatDate
                    setDate={data.date}
                    format={{
                        day: 'numeric',
                        month: 'numeric',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                    }}
                />
            </td>
            <td className={classes.Cell}>
                {data.firstName} {data.patronymic} {data.lastName}
            </td>
            <td className={classes.Cell}>{data.email}</td>
            <td className={classes.CellCenter}>
                <span style={{ color: status.color }}>{status.name}</span>
            </td>
        </tr>
    );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AccountsList/TableRow.js